import { useMemo } from "react";
import { CHART_COLORS } from "@/lib/constants";

// Pictogram: tiap baris = kategori, tiap ikon orang = `perIkon` pekerja (otomatis agar maksimal ~20 ikon/baris)
const Orang = ({ fill, frac = 1, size }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className="shrink-0" aria-hidden="true">
    <defs>
      <linearGradient id={`g-${fill}-${frac}`} x1="0" x2="1">
        <stop offset={frac} stopColor={fill} />
        <stop offset={frac} stopColor="#E2E8F0" />
      </linearGradient>
    </defs>
    <path fill={frac >= 1 ? fill : `url(#g-${fill}-${frac})`}
      d="M12 2a3.2 3.2 0 1 1 0 6.4A3.2 3.2 0 0 1 12 2Zm-4.5 9.2A2.7 2.7 0 0 1 10.2 8.5h3.6a2.7 2.7 0 0 1 2.7 2.7V15h-1.6v7h-2v-5.4h-1.8V22h-2v-7H7.5v-3.8Z" />
  </svg>
);

export default function PictogramRender({ data, height = 260, maxIkon = 20 }) {
  const rows = useMemo(() => [...data].sort((a, b) => b.value - a.value), [data]);
  const total = rows.reduce((s, r) => s + (r.value || 0), 0);
  const maxVal = Math.max(1, ...rows.map((r) => r.value || 0));
  const perIkon = Math.max(1, Math.ceil(maxVal / maxIkon));
  const size = rows.length > 12 ? 20 : rows.length > 6 ? 24 : 30;
  return (
    <div className="overflow-y-auto pr-1" style={{ maxHeight: height }} data-testid="pictogram">
      <p className="text-[11px] text-slate-400 mb-2">1 ikon = {perIkon} orang · total {total}</p>
      <div className="space-y-1.5">
        {rows.map((r, i) => {
          const fill = CHART_COLORS[i % CHART_COLORS.length];
          const n = (r.value || 0) / perIkon;
          const full = Math.floor(n), sisa = n - full;
          const pct = total ? Math.round((r.value / total) * 1000) / 10 : 0;
          return (
            <div key={r.name} className="flex items-center gap-2" title={`${r.name}: ${r.value} orang (${pct}%)`} data-testid={`pictogram-row-${i}`}>
              <span className="w-28 shrink-0 truncate text-[11px] font-medium text-slate-700">{r.name}</span>
              <div className="flex flex-wrap items-center gap-0.5 flex-1">
                {Array.from({ length: full }, (_, k) => <Orang key={k} fill={fill} size={size} />)}
                {sisa > 0.05 && <Orang fill={fill} frac={sisa} size={size} />}
              </div>
              <span className="w-14 shrink-0 text-right text-xs font-bold tabular-nums text-slate-900">{r.value}</span>
              <span className="w-12 shrink-0 text-right text-[11px] tabular-nums text-slate-400">{pct}%</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
